<template>
<div v-if="showInspector || showAgent">
  <v-layout class="my-team">
    <v-flex class="title-column">
      <h3>MY TEAM</h3>
    </v-flex>
    <v-flex>
      <hg-team-member-list
        v-if="showInspector"
        class="team-list inspector"
        :hg-members="inspectors"
        :hg-link="inspectorLink"
        hg-parent-component="INSPECTION"
        :hg-show-inspector-agent-photos="showInspectorAgentPhotos"/>
      <hg-team-member-list
        v-if="showAgent"
        class="team-list agent"
        :hg-members="agents"
        hg-parent-component="INSPECTION"
        :hg-show-inspector-agent-photos="showInspectorAgentPhotos"/>
    </v-flex>
  </v-layout>
  </div>
</template>


<script>
import AccountClient from '@/utilities/account-client';
import { mapGetters, mapState } from 'vuex';
import TeamMemberList from '../Shared/TeamMemberList.vue';

export default {
  components: {
    'hg-team-member-list': TeamMemberList,
  },
  props: {
    hgAgents: {
      type: Array,
      required: true,
    },
    hgInspectors: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      inspectors: [],
      agents: [],
      clients: {},
    };
  },
  computed: {
    ...mapGetters('User', ['userAuthToken']),
    ...mapState('unleash', {
      enabledFeatures: state => state.enabledFeatures,
    }),
    inspectorLink() {
      return 'rate';
    },
    showAgent() {
      return this.hgAgents.length > 0;
    },
    showInspector() {
      return this.hgInspectors.length > 0;
    },
    showInspectorAgentPhotos() {
      return !!this.enabledFeatures['HG-731-Show-Inspector-Agent-Photos'];
    },
  },
  async mounted() {
    this.inspectors = this.hgInspectors.map(obj => ({ ...obj, profileUrl: '' }));
    this.agents = this.hgAgents.map(obj => ({ ...obj, profileUrl: '' }));
    if (this.showInspectorAgentPhotos) {
      this.initializeClients();
      await this.fetchProfileUrl();
    }
  },
  methods: {
    initializeClients() {
      this.clients.accountClient = new AccountClient(
        process.env.VUE_APP_ROOT_API,
        this.userAuthToken,
      );
    },
    fetchProfileUrl() {
      this.updateProfileUrl(this.inspectors);
      this.updateProfileUrl(this.agents);
    },
    updateProfileUrl(members) {
      // eslint-disable-next-line no-restricted-syntax
      for (const member of members) {
        // eslint-disable-next-line no-await-in-loop
        this.updateMember(member);
      }
    },
    updateMember(member) {
      this.clients.accountClient.getUserProfile(member.personId)
        .then(response => {
          // eslint-disable-next-line no-param-reassign
          member.profileUrl = response.data.profileUrl;
        }).catch(() => {
          // TODO: Show error when error
        });
    },
  },
};
</script>


 <style lang="scss" scoped>
.title-column {
  flex: 0 0 180px;
}

.team-list:first-child {
  margin-bottom: 30px;
}

.member-list {
  border-bottom: solid 1px rgba(0, 0, 0, 0.15);

  &:last-child {
    border-bottom: none;
  }
}

@media all and (max-width: 655px) {
  .my-team {
    margin-left: 30px;
    flex-direction: column;
  }

  .title-column {
    flex: 1 1 auto;
    padding-bottom: 20px;
  }
}
 </style>
